<div class="setup">
  <section class="setup__card" aria-labelledby="setup-title">
    <img class="setup__mascot" src="assets/images/mokkie/mokkie-guide.png" alt="" width="96" height="96" aria-hidden="true" />
    <p class="setup__eyebrow">Dernière étape</p>
    <h1 id="setup-title" class="setup__title">Créez votre <span class="setup__accent">organisation</span></h1>
    <p class="setup__text">Donnez-lui un nom, par exemple celui de votre entreprise. Vous pourrez le modifier plus tard.</p>

    <form class="setup__form" (submit)="createOrganisation($event)">
      <app-input-text
        class="setup__field"
        label="Nom de l'organisation"
        placeholder="Ex. : Les Cafés Martin"
        autocomplete="organization"
        icon="iconoirBuilding"
        [required]="true"
        [maxLength]="maxLength"
        [errorMessage]="fieldError() ?? ''"
        [ngModel]="organisationName()"
        (ngModelChange)="onNameChange($event)"
        name="organisation"
      />

      @if (errorMessage()) {
        <p class="setup__error" role="alert">{{ errorMessage() }}</p>
      }

      <app-btn
        class="setup__submit"
        [config]="{ type: 'filled', color: 'coffee', icon: 'iconoirArrowRight', loading: submitting() }"
        (click)="createOrganisation()"
      >
        {{ submitting() ? 'Création en cours…' : 'Créer mon organisation' }}
      </app-btn>
    </form>
  </section>
</div>
